
<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">设置</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container4" style="margin-top: 60px;">
        <div class="filter-container2">
          <el-form label-width="200px" style="font-size: 18px;margin-right: 60px;">
              
              <el-form-item  label="课程提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.tomorrowBookLessonWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch>
                <el-switch width="60"
                  v-model="notify.tomorrowBookLessonTts"
                  active-text="语音消息"
                  inactive-text="">
                </el-switch>
              </el-form-item>
              <el-form-item  label="生日提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.birthday"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <!-- <el-switch width="60"
                  v-model="notify.birthdayWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch> -->
              </el-form-item>
              <el-form-item  label="30天未到店:"  prop="name">
                <el-switch width="60"
                  v-model="notify.notArrived"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <!-- <el-switch width="60"
                  v-model="notify.notArrivedWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch> -->
              </el-form-item>
              <el-form-item  label="员工合同到期提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.workerAgreementTime"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <!-- <el-switch width="60"
                  v-model="notify.notArrivedWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch> -->
              </el-form-item>
              <el-form-item  label="开卡提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.buyCard"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <el-switch width="60"
                  v-model="notify.buyCardWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch>
              </el-form-item>
              <el-form-item  label="卡过期提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.cardExpire"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <el-switch width="60"
                  v-model="notify.cardExpireWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch>
              </el-form-item>
              <el-form-item  label="消费后:" prop="name">
                <el-switch width="60"
                  v-model="notify.afterConsume"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <el-switch width="60"
                  v-model="notify.afterConsumeWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch>
              </el-form-item>
              <el-form-item  label="预约提醒:"  prop="name">
                <el-switch width="60"
                  v-model="notify.bookLesson"
                  active-text="发短信"
                  inactive-text="">
                </el-switch>
                <el-switch width="60"
                  v-model="notify.bookLessonWechat"
                  active-text="微信模版消息"
                  inactive-text="">
                </el-switch>
              </el-form-item>
              
          </el-form>
        </div>
        <div style="margin-top: 60px;">
          <el-button type="primary" class="operator-btn" style="width: 120px;"  @click="updateNotify">保存</el-button>
        </div>
      </div>
    </el-card>

  </div>

</template>

<script>


  import globaldata from "../../../../utils/globaldata";
  import {getVccNotifySwitch, updateVccNotifySwitch} from "../../../../api/StoreSetting";
  import commonUtils from "../../../../utils/commonUtils";
  import messageUtils from "../../../../utils/messageUtils";

  export default {
    data() {
      return {
        notify:{
          afterConsume:false,
          bookLesson:false,
          birthday:false,
          buyCard:false,
          cardExpire:false,
          notArrived:false,
        }

      }
    },
    mounted() {

    },
    created(){

      this.fetchDate();
    },
    methods: {

      fetchDate(){
        this.notify.storeFrontId = globaldata.getAdminStore().storeFrontId;
        let param = {
          storeFrontId : globaldata.getAdminStore().storeFrontId,
        }
        getVccNotifySwitch(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.notify = data;
        })
      },

      updateNotify(){
        this.notify.storeFrontId = globaldata.getAdminStore().storeFrontId;
        let param = this.notify;
        updateVccNotifySwitch(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          if (date == true){
            messageUtils.successMsg(this,response.message);
            this.fetchDate();
          }
        })
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/store-setting/notify/index.vue